export default __webpack_public_path__ + "images/2f1881073dac1707625e9baa6c2963f1-helicopter2.png";